import { Animation } from '../../../../interface';

export function leaveAnimationBottom(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const backdropAnimation = new AnimationC();
  backdropAnimation.addElement(baseEl.querySelector('lar-backdrop'));

  const wrapperAnimation = new AnimationC();
  const wrapperEl = baseEl.querySelector('.lar-modal-wrapper');
  wrapperAnimation.addElement(wrapperEl);

  wrapperAnimation.beforeStyles({ 'opacity': 1 })
                  .fromTo('translateY', '0%', '100vh');

  backdropAnimation.fromTo('opacity', 'var(--lar-backdrop-opacity, .6)', 0.0);

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('ease-out')
    .duration(250)
    .add(backdropAnimation)
    .add(wrapperAnimation));
}

export function leaveAnimationRight(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const backdropAnimation = new AnimationC();
  backdropAnimation.addElement(baseEl.querySelector('lar-backdrop'));

  const wrapperAnimation = new AnimationC();
  const wrapperEl = baseEl.querySelector('.lar-modal-wrapper');
  wrapperAnimation.addElement(wrapperEl);

  wrapperAnimation.beforeStyles({ 'opacity': 1 })
                  .fromTo('translateX', '0%', '100vw');

  backdropAnimation.fromTo('opacity', 'var(--lar-backdrop-opacity, .6)', 0.0);

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('ease-out')
    .duration(250)
    .add(backdropAnimation)
    .add(wrapperAnimation));
}
